export default {
      id: "273,4_cm_=_100_+_70_+_100-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#273,4_cm_=_100_+_70_+_100",
      toString: function () {
        return this.url;
      }
    }